import { Box, Button, Grid } from "@mui/material";
import SourceExplorer from "../../components/organisms/sourceExplorer/SourceExplorer";
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from "react-router-dom";
import { getRoleClaimsSelector } from "../../store/auth/selectors";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const DataSourceList = () => {

    const roles = useSelector(getRoleClaimsSelector);  // roles  - IDP.Admin or IDP.User

    const [isAdmin, setIsAdmin] = useState(true);

    const navigate = useNavigate();

    const addNewSource = (event: React.MouseEvent<HTMLButtonElement>) => {
        const url = "/AddDataSource";
        if (event.ctrlKey) {
            window.open(url, '_blank')
        } else {
            navigate(url);
        }
    }

    useEffect(() => {
        if (roles && roles.length > 0) {
            setIsAdmin(roles.includes("IDP.Admin") ? true : false);
        }
    }, [roles]);


    return (
        <>
            <Box sx={{ paddingBottom: "10px" }}>
                <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center">
                    <Grid item xs={8}>
                        <h1 style={{ textAlign: "left" }}>Data Sources </h1>
                    </Grid>
                    <Grid item xs={4} style={{ textAlign: "right" }}>
                        {isAdmin && <Button id="78ff35c5-a1d4-47c1-a2c2-b22392573f81" color="primary" variant="contained" onClick={addNewSource} endIcon={<AddIcon />}>
                            Add Data Source
                        </Button>}
                    </Grid>
                </Grid>
            </Box>
            <SourceExplorer isAdmin={isAdmin} />
        </>
    )
}

export default DataSourceList;